var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1728813275516,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 4941,
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 512C0 229.2224 229.2224 0 512 0s512 229.2224 512 512-229.2224 512-512 512S0 794.7776 0 512z",
    fill: "#FF6251",
    "p-id": 4942
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M303.9232 396.4416a58.88 58.88 0 0 1 83.2512-83.2L512 438.0672l124.8256-124.8256a58.88 58.88 0 1 1 83.2 83.2l-124.8256 124.8256 124.8256 124.8256a58.88 58.88 0 0 1-83.2512 83.2L512 604.4672l-124.8256 124.8256a58.88 58.88 0 0 1-83.2512-83.2l124.8256-124.8256-124.8256-124.8256z",
    fill: "#FFFFFF",
    "p-id": 4943
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.5e7e9c86c4c1eb5dc397aa3612c0448f.svg";
export { ForwardRef as ReactComponent };